import React from 'react';
import { t } from '@lingui/macro';
import { FaUndoAlt, FaUserPlus } from 'react-icons/fa';

import { useLayoutContext } from '../Layout/LayoutProvider/LayoutContext';
import { useAccessibilityContext } from '../Providers/AccessibilityProvider/AccessibilityContext';
import { AccessibilityOption } from './AccessibilityButton';

const ResetAccessibilityOption = () => {
  const {
    fontSize,
    setFontSize,
    setIsDislexic,
    setIsHightlightLink,
    setIsCursorBig,
    setStorytellerEnabled,
    setLangTeller,
    setLanguaje,
    setIsReadingGuideEnabled,
  } = useAccessibilityContext();
  const {
    layout: { setIsGrayScaled, setIsHightContrast },
  } = useLayoutContext();

  function resetSizeFont() {
    const fonts = document.querySelectorAll(
      'span:not(.glyphicon), p, a, h1, h2, h3, h4, h5, input, div,strong:not(.fa)'
    );
    fonts.forEach((el: any) => {
      const style = window.getComputedStyle(el);
      const currentFontSize = parseFloat(style.fontSize);
      if (fontSize) {
        el.style.fontSize = `${currentFontSize - fontSize}px`;
      }
      if (setFontSize) {
        setFontSize(0);
      }
    });
  }

  function resetOptions() {
    resetSizeFont();
    if (setIsDislexic) {
      setIsDislexic(false);
    }
    if (setIsGrayScaled) {
      setIsGrayScaled(false);
    }
    if (setIsHightContrast) {
      setIsHightContrast(false);
    }
    if (setIsHightlightLink) {
      setIsHightlightLink(false);
    }
    if (setIsCursorBig) {
      setIsCursorBig(false);
    }
    if (setStorytellerEnabled) {
      setStorytellerEnabled(false);
    }
    if (setLangTeller) {
      setLangTeller('es-ES');
    }
    if (setLanguaje) {
      setLanguaje('es');
    }
    if (setIsReadingGuideEnabled) {
      setIsReadingGuideEnabled(false);
    }
  }

  return (
    <AccessibilityOption
      name={'Restablecer'}
      icon={<FaUndoAlt className="h-3 w-3 fill-white" />}
      onClick={resetOptions}
    />
  );
};

export default ResetAccessibilityOption;
